/**
 * Created by Administrator on 2020-09-02.
 */
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import Bus from '@/layouts/bus'
export function exportMethod (data) {
  // request interceptor
  axios.interceptors.request.use(config => {
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (token) {
      config.headers['accessToken'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config
  })
  Bus.$emit('showSpinning', true, '准备导出...')
  axios({
    method: data.method,
    // url: `${data.url}${data.params ? '?' + data.params : ''}`,
    url: `${data.url}`,
    data: data.data,
    responseType: 'blob'
  }).then((res) => {
    const link = document.createElement('a')
    const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
    var fileReader = new FileReader()
    fileReader.readAsText(blob, 'UTF-8')
    fileReader.onload = function () {
      //  请求失败会执行try catch中的方法
      try {
        var jsonData = JSON.parse(this.result)
        if (jsonData.code !== '0') {
          notification.error({
            message: jsonData.message
          })
          return ''
        }
      } catch (err) {
      }
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      // 下载的文件名
      link.download = data.fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }).catch(error => {
    notification.error({
      message: '请求失败'
    })
    console.log(error)
  }).finally(res => {
    Bus.$emit('showSpinning', false)
  })
}